import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getProfileRequest, getProfileRequestError, getProfileRequestSuccess } from "../../slices/Profile/GetProfileSlice";

export const GetProfileAPI = () => async (dispatch) => {
    try {
        dispatch(getProfileRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getProfile,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getProfileRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getProfileRequestError(_error));
            });
    } catch (error) { }
};
